"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.form.label': 'Etykieta',
    'slotData.form.value': 'Wartość',
    'slotData.form.type': 'Typ',
};
